export async function generateDesignTerms(imageUrl: string, isFullPrompt: boolean = false): Promise<string[]> {
  try {
    const res = await fetch('/api/ai/analyze', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ imageUrl, isFullPrompt })
    });

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || `AI analysis request failed with status ${res.status}`);
    }

    const { results, error } = await res.json();
    if (error) {
      throw new Error(error);
    }
    
    return results || [];
  } catch (error) {
    console.error("Error generating design terms with Ark (Proxy):", error);
    return ["Design", "Inspiration"];
  }
}
